// @ubm/product-ui/blocks/week-calendar — placement PUR des évènements qui se chevauchent dans une journée : grappes de
// chevauchement, puis colonnes gloutonnes (premier couloir libre). Retourne, par évènement, son couloir et la largeur
// de sa grappe ; les voisins se resserrent sans changer d'ordre.

export interface Placed { id: string; start: number; end: number }
export interface Lane { lane: number; lanes: number }

export function placeOverlaps(items: readonly Placed[]): Map<string, Lane> {
  const sorted = [...items].sort((a, b) => a.start - b.start || b.end - a.end || a.id.localeCompare(b.id));
  const out = new Map<string, Lane>();
  let cluster: { id: string; lane: number }[] = [];
  let laneEnds: number[] = [];
  let clusterEnd = -Infinity;
  const flush = () => {
    const lanes = Math.max(1, laneEnds.length);
    for (const c of cluster) out.set(c.id, { lane: c.lane, lanes });
    cluster = [];
    laneEnds = [];
  };
  for (const item of sorted) {
    if (item.start >= clusterEnd) { flush(); clusterEnd = -Infinity; }
    let lane = laneEnds.findIndex(end => end <= item.start);
    if (lane < 0) { lane = laneEnds.length; laneEnds.push(item.end); } else laneEnds[lane] = item.end;
    cluster.push({ id: item.id, lane });
    clusterEnd = Math.max(clusterEnd, item.end);
  }
  flush();
  return out;
}
